module.exports = __webpack_public_path__ + "static/img/image-storecenter.b1d1ba9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/image-storecenter.png
// module id = 9TDJ
// module chunks = 150